export default "__VITE_ASSET__DqyBMWi___"